import axios from "axios";
import { baseURL } from "./config.js";
import qs from "qs";

// 用户管理
export default {
  userList(params) {
    // 用户列表
    const url = baseURL + "/tbUser/userList";
    return axios.post(url, qs.stringify(params));
  },
  getUserDetail(params) {
    // 用户详情
    const url = baseURL + "/tbUser/getDetail";
    return axios.post(url, qs.stringify(params));
  },
  companyList(params) {
    // 企业用户列表
    const url = baseURL + "/tbCompany/list";
    return axios.post(url, qs.stringify(params));
  },
  addCompanyList(params) {
    // 新增企业用户
    const url = baseURL + "/tbCompany/modify";
    return axios.post(url, qs.stringify(params));
  },
  delCompanyList(params) {
    // 删除企业用户
    const url = baseURL + "/tbCompany/delete";
    return axios.post(url, qs.stringify(params));
  },
  setCompanyManager(params) {
    // 设置企业用户管理员
    const url = baseURL + "/tbUser/setCompanyManager";
    return axios.post(url, qs.stringify(params));
  },

  getCode(params) {
    // code码
    const url = baseURL + "/tbCode/list";
    return axios.post(url, qs.stringify(params));
  },

  userListByDay(params) {
    // 日活用户量
    const url = baseURL + "/tbUser/userListByDay";
    return axios.post(url, qs.stringify(params));
  },

  userListByExcel(params) {
    // 日活导出
    const url = baseURL + "/tbUser/userListByExcel";
    return url;
  },

  allUserByExcel(params) {
    // 用户导出
    const url = baseURL + "/tbUser/allUserByExcel";
    return url;
  },

  allAdminuser(param) {
    //查询出所有客户经理
    const url =
      baseURL +
      "/tbAdminuser/list?type=2&token=" +
      param.token +
      "&checkCode=" +
      param.checkCode;
    return axios.get(url);
  },

  getComputeDetail(id) {
    //获取企业详情接口
    const url = baseURL + "/tbCompany/getDetail?id=" + id;
    return axios.get(url);
  },

  getCompanyManage(param) {
    //获取企业管理员
    const url =
      baseURL +
      "/tbCompany/getCompanyManage?companyId=" +
      param.companyId +
      "&token=" +
      param.token +
      "&checkCode=" +
      param.checkCode;
    return axios.get(url);
  },

  getCompanyUser(param) {
    //获取公司下的所有人
    const url =
      baseURL +
      "/tbCompany/getCompanyUser?companyId=" +
      param.companyId +
      "&token=" +
      param.token +
      "&checkCode=" +
      param.checkCode;
    return axios.get(url);
  },

  setCompanyManager(params) {
    const url =
      baseURL +
      "/tbUser/setCompanyManager?companyid=" +
      params.companyid +
      "&userid=" +
      params.userid +
      "&toke=" +
      params.toke +
      "&checkCode=" +
      params.checkCode;
    return axios.get(url);
  },

  // 根据名称模糊查询企业列表
  getCompanySearch(param) {
    const url = baseURL + "/tbCompany/companySearch";
    return axios.post(url, param);
  },

  // 校验企业名称是否唯一
  checkCompanyUnique(param) {
    const url = baseURL + "/tbCompany/companyCheck?name=" + param.name;
    return axios.post(url);
  },
};



// WEBPACK FOOTER //
// ./src/api/user.js